import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../Modules/Shared/Services/api.service';
import { endpoints } from '../../../environments/endpoints';
import { LazyLoadListResponse } from '../../Modules/Shared/Interfaces/response.interface';

@Injectable({
    providedIn: 'root',
})
export class NextService {
    private _apiService = inject(ApiService);

    getNext<T>(nextLink: string, skipLoading: boolean = true): Observable<LazyLoadListResponse<T>> {
        const request = this._apiService.get<LazyLoadListResponse<T>>(endpoints.api.intune.next.get, {
            params: { url: nextLink },
            skipLoading,
        });
        return this._apiService.run<LazyLoadListResponse<T>>(request);
    }
}